import { Injectable, HostListener, Inject } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { WINDOW } from "./windows.service";
import { AuthService } from '../../core/services/AuthService';

// Menu
export interface Menu {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	children?: Menu[];
	roles?: string[]; // 👈 NUEVO: define qué roles pueden ver este ítem
}

@Injectable({
	providedIn: 'root'
})

export class NavService {

	public screenWidth: any
	public collapseSidebar: boolean = false
	private tokenSubscription: Subscription; // Almacena la suscripció

	// 1. Definimos los items originales (Privado para que nadie los toque)
    private readonly MENUITEMS: Menu[] = [
        		{
			path: '/dashboard/default', title: 'Inicio', icon: 'home', type: 'link', badgeType: 'primary', active: false
		},
		{
			title: 'Firmas', icon: 'edit-3', type: 'sub', active: false, children: [
				// { path: '/firmas/plantillas', title: 'Plantillas', type: 'link', roles: ['ADMINISTRADOR'], },
				// { path: '/firmas/firma', title: 'Firma365', type: 'link' },
				{ path: '/firmas/admin-simple', title: 'Individual', type: 'link', },
				{ path: '/firmas/admin-lotes', title: 'Sobres', type: 'link', },
				{ path: '/firmas/admin-plantillas', title: 'Plantillas', type: 'link' },
			]
		},
		{
			title: 'Usuarios', 
			icon: 'user-plus', 
			type: 'sub', 
			active: false, 
			roles: ['ADMINISTRADOR'],   // solo admin maneja usuarios

			children: [
				{ path: '/users/create-user', title: 'Crear Usuarios', type: 'link' },
				// { path: '/users/list-user', title: 'User List', type: 'link' },
			]
		},		
		{
			title: 'Configuraciones', icon: 'settings', type: 'sub', active: false,
			 children: [
				// { path: '/firmas/plantillas', title: 'Plantillas', type: 'link', roles: ['ADMINISTRADOR'], },
				// { path: '/firmas/firma', title: 'Firma365', type: 'link' },
				{ path: '/parametros/parametros', title: 'Parámetros', type: 'link', roles: ['ADMINISTRADOR'] },
				{ path: '/institucion/institucion', title: 'Institución', type: 'link', roles: ['ADMINISTRADOR'] },
				{ path: '/signature-size/signature-size', title: 'Área de firma', type: 'link' },
				{ path: '/accesos/accesos', title: 'Gestion de accesos', type: 'link', roles: ['ADMINISTRADOR'] },
			],
		},
		{
			title: 'Integraciones', 
			roles: ['ADMINISTRADOR'],
			icon: 'refresh-cw', type: 'sub', active: false, children: [
				{ path: '/integraciones/servicios-externos', title: 'Servicios Externos', type: 'link',  roles: ['ADMINISTRADOR'] }
			]
		},
		{
			title: 'Perfil',path: '/perfil/perfil', icon: 'user-check', type: 'link', active: false
		},
		{
			 path: '/groups/list-group', title: 'Grupos',icon: 'users' ,  type: 'link' , active: false
		}
    ];

    // 2. Este es el Subject que escuchará el componente del Sidebar
    public items = new BehaviorSubject<Menu[]>([]);

	constructor(@Inject(WINDOW) private window, private authService: AuthService) {
		this.onResize();
        if (this.screenWidth < 991) {
            this.collapseSidebar = true;
        }
        
        // 🔄 ESCUCHA DEL TOKEN: Cada vez que el token$ emita un valor (Login/Logout/Refresh)
        // el menú ejecutará de inmediato la re-evaluación con los roles del nuevo JWT.
        this.tokenSubscription = this.authService.token$.subscribe((token) => {        
            this.updateMenu();
        });
	}

	public updateMenu() {
        // 1. Clonamos la estructura original de forma segura usando structuredClone
        // Si usas una versión muy antigua de Node/navegadores, puedes usar JSON.parse(JSON.stringify(this.MENUITEMS))
        const menuCopy = structuredClone(this.MENUITEMS);
        
        // 2. Filtramos sobre la copia limpia
        const filteredMenu = this.filterItems(menuCopy);
        this.items.next(filteredMenu);
    }

    private filterItems(items: Menu[]): Menu[] {
        return items.filter(item => {
            // Si el item no tiene roles definidos, es público (como 'Inicio' o 'Perfil')
            if (!item.roles || item.roles.length === 0) {
                // Si tiene hijos, también filtramos los hijos recursivamente
                if (item.children) {
                    item.children = this.filterItems(item.children);
                }
                return true;
            }

            // Si tiene roles, verificamos si el usuario tiene AL MENOS UNO de esos roles
            const hasAccess = item.roles.some(role => this.authService.hasRoleAuth(role));
			
            if (hasAccess && item.children) {
                item.children = this.filterItems(item.children);
            }

            return hasAccess;
        });
    }

	@HostListener("window:resize", ['$event'])
    onResize(event?) {
        this.screenWidth = window.innerWidth;
    }

}
